import { InfoBar } from '@2n/design-system';
import InfoIcon from '@mui/icons-material/Info';
import * as React from 'react';

export interface IInfoBarData {
  children: React.ReactNode;
}

export function OutlinedInfoBar(data: IInfoBarData) {
  return (
    <InfoBar
      props={{
        icon: <InfoIcon color="secondary" />,
      }}
      sx={{
        color: 'secondary.main',
        my: 2,
      }}
      type="info"
      variant="outlined"
    >
      {data.children}
    </InfoBar>
  );
}
